module.exports = __webpack_public_path__ + "static/media/emojis2_22.de90c307.svg";